<template>
  <printstickerbyshippingid-component>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            
            <strong>Print Sticker Using ShippingId</strong>
          
          </div>
          <div id="printableArea" >
            <div class="page-break" v-for="item in printdata" >
              <table>
                  <tr >
                    <td >
                     <div>
                      <!-- border = '1' -->
                      <table  class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 0px;'>
                          <img id='test'/>
                          <div id="app" >

                          <barcode v-bind:value="item.shippingid">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>

                      <tr>
                        <td colspan='2' class="addpad">

                          <span style='font-size: 25px;'><b>{{item.customername}}</b></span> <br>
                          <span style='font-size: 20px;'><b>{{item.pickuplocationaddress}}</b> </span><br>
                          <span style='font-size: 20px;'><b>Contact:</b>{{item.pocmobilenumber}}</span><br>
                          <span style='font-size: 20px;'><b>Vendor Name:</b>{{item.vendor_name}}</span><br>
                          <span style='font-size: 20px;'><b>Zone Name:</b> {{item.zone_name}}</span><br>
                          <span style='font-size: 20px;'><b>POID:</b>{{item.orderid}}</span><br>
                          <span style='font-size: 20px;'><b>FCID:</b> {{item.productid}}</span><br>
                          <span style='font-size: 20px;'><b>Quantity:</b> {{item.productquantity}}</span>
                          <br>
                           <span style='font-size: 20px;'><b>Sr Reason:</b> {{item.sr_reason}}</span>
                          <br>
                        </td>
                      </tr>
                     
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div>
           <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >  
                  <b-col sm="12" >
                  <b-form-group label="Enter Shipping Id" :label-cols="4"> 
                    <b-form-input class="input" type="text" name="shipping_id" @click="inputsearch()" v-model="customer.shipping" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.shipping_id') }" placeholder="Enter Shipping Id ">
                   </b-form-input>
                    <span v-show="errors.has('form-1.shipping_id')" class="help text-danger">{{ errors.first('form-1.shipping_id') }}</span>
                   </b-form-group> 
                   </b-col>         
                </b-col> 
                <b-col md="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clearshippingid"> Clear</b-button>               
                </b-col>
              </b-row>  
            </form>
          </div>   
             <br>
             <br>  
            
          <b-col sm="12" class="text-right">
               
              <b-row >
              <b-col sm="12" class="text-left">
              <!--  <span v-if="this.totalRows>0">
                <input type='checkbox' @click='checkAll()' v-model='isCheckAll' id="allseleted" >
              Select All</span> -->
              <b-button
                v-show="showPrintButton"
                id="printbutton"
                variant="primary"
                size="md"
                @click="barcodedata('printableArea')">
                Print Receipt
              </b-button>
            </b-col>
            </b-row>
          </b-col>
              
         
        </b-card>
      </b-col>
    </b-row>
  </div>
</printstickerbyshippingid-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';
import VueBarcode from 'vue-barcode';
export default {
  data: function() {
    return {
      data: [],
      checkedShipmentID:[],
      items:[],
      selected:'',
      isBusy: false,
      hubid:'',
      printdata:[],
      orderid:[],
      barcodes:[],
      
      barcodeValue:['test2243'],

      ordercodeValue:['5CD1332458'],

      shippingidx:[],
      printstickerdata:[],

      
        
        // isCheckAll: false,
      customer:{},
      showPrintButton: false
        
       
    };
  },
   components: {
    'barcode': VueBarcode
  },



  computed: {
    sortOptions() {
      }
  },
  created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.hubid=userInfo.pickuplocationmasterid.toString();
    
  },
  methods: {
    validateForm(scope) {
      //alert(" i m in validation ");
    
      this.$validator.validateAll(scope).then(result => {
        if (result) { 
          this.showPrint();
        }
      });
    },
    inputsearch:function(){
      this.showPrintButton = false;
    	// document.getElementById("printbutton").style.display ="none";
    },
    showPrint:function(){
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      
      const isValid = this.customer.shipping.startsWith('Q');
      if (!isValid) {
          this.$fire({
              text: "Invalid Shipment",
              type: "error",
              timer: 30000
          });
          document.getElementById("overlay").style.display = "none";
          return;
      }

       var shippingidobj = 
       { 
           awbno :this.customer.shipping,
           hub_id:`${userInfo.pickuplocationmasterid}`,


         };
         console.log("Yes",shippingidobj);

        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getPrintReverseShipmentList`,shippingidobj)
            .then(result => {
              document.getElementById("overlay").style.display = "none";
           if (result.body.returnmsg ==='Successful' ) {    
              this.printdata = result.body.returnvalue;
              // document.getElementById("printbutton").style.display ="block";
              this.showPrintButton = true;
            }else{
              this.$fire({
                  text:result.body.returnvalue,
                  type: "warning",
                  timer: 30000
                }); 
               this.printdata=[];
               this.showPrintButton = false;

            }
            })
            .catch(ex => {
              console.log('error-----', ex)
            });
      },
     
    clearshippingid:function(){
    	
    	this.customer={};
    	// document.getElementById("printbutton").style.display ="none";
      this.showPrintButton = false;
    },



    barcodedata(printableArea){

     var printContents = document.getElementById("printableArea").innerHTML;

    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:6px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:auto} ');
      docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

      docprint.document.write('.addpad{ padding-left: 3px; padding-right: 3px; }');


       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:2px; }}');

docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


        docprint.document.write('.stickertable td{ padding-bottom:2px;  }');

        docprint.document.write('@page { size: 101.6mm 85.2mm;}</style>');


        //docprint.document.write('@media print { td.page-break  { display: block; page-break-before: always; } } </style>');  


  

       docprint.document.write('</head><body onLoad="self.print()"><center>');



       // docprint.document.write('<script type="text/javascript">function CloseWindow() { window.close() }');


        // docprint.document.write('<a  onclick="CloseWindow();" href="#">Here</a> to close this window.');
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();
           let mediaQueryList= window.matchMedia('print')
          if (mediaQueryList) {
            this.handleBeforePrint();
          }

    },

    handleBeforePrint() {
      this.$fire({
                  text:"Please Close Print Tab First",
                  type: "warning",
                  timer: 300000
                }); 
    //  this.isPrintDialogOpen = true;
  },
    CloseWindow() {
        docprint.close();
    },
  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
.stickertable{
     border-collapse: collapse;margin-bottom: 20px; page-break-after:always;
;width:360px;height:540px;

}
.printarea{
  font-size: 20px;text-align: center;
}

.stickertable td{
  padding-bottom:10px;
   page-break-after:always;

}

@media all {
.page-break { display: none; }
}

@media print {
.page-break { display: block; page-break-before: always; }
}
.addpad{
  padding: 10px;
}        
</style>
